module.exports = __webpack_public_path__ + "img/党员积分商城.1ea7433a.png";